import { api } from "./api";

export type BudgetSource = "auto" | "manuell" | "mix";

export interface BudgetRow {
  categoryId: string | null;
  categoryName: string;
  categoryFullPath: string;
  direction: "INCOME" | "EXPENSE" | "TRANSFER";
  plannedCents: number;
  actualCents: number;
  varianceCents: number;
  actualSource: BudgetSource;
  staleAccountIds: string[];
  transactionCount: number;
  cashflowActualCount: number;
}

export interface MonthlyBudget {
  month: string;
  rows: BudgetRow[];
  totals: {
    plannedIncomeCents: number;
    plannedExpenseCents: number;
    actualIncomeCents: number;
    actualExpenseCents: number;
  };
}

export const budgetApi = {
  getMonthly: (month?: string) =>
    api<MonthlyBudget>(`/budget/monthly${month ? `?month=${encodeURIComponent(month)}` : ""}`),
};
